module.exports = __webpack_public_path__ + "img/tech13mb.fb96774a.png";